module.exports = __webpack_public_path__ + "img/ipad.836e8d7f.png";